<irembogov-generic-file-upload
  [id]="field.key"
  formControlName="profilePicture"
  [noFileSubLabelHtml]="'or drag and drop'"
  [formControl]="formControl"
  [allowedFormats]="field.props['allowedFormats']"
  [maximumUploadSize]="field.props['maximumUploadSize']"
  id="profileImage"></irembogov-generic-file-upload>
